import { Parse } from '@cadstrom/cadstrom-shared';

import { DrawingManagerContext } from '../context/drawing-manager-context.js';
import TogglePolygonFillIcon from './toggle-polygon-fill-icon.js';
import { ToolbarItem } from './toolbar-item.js';

import type { ElementType } from 'react';
import type { DrawingManagerContextValue } from '../context/drawing-manager-context.js';
import type { IToolbarItem, IToolbarItemState } from './toolbar-item.js';

interface IOwnState extends IToolbarItemState {}

export class TogglePolygonFillToolbarItem extends ToolbarItem<IOwnState> implements IToolbarItem {
	public static readonly ItemId = 'togglepolyfill';
	id: string = TogglePolygonFillToolbarItem.ItemId;
	title = 'Show/hide polygon fills';
	keyEventName = 'TOGGLE_POLYFILL';
	defaultKeyBinding = 'shift+p';
	iconElement: ElementType = TogglePolygonFillIcon;
	includeInHistory = false;
	// @ts-expect-error
	context: DrawingManagerContextValue | undefined;

	public override componentDidMount(): void {
		if (super.componentDidMount) {
			super.componentDidMount();
		}

		this.onActiveStateChanged(this.props.active);
	}

	public onActiveStateChanged(isActive: boolean) {
		this.context?.drawingManager?.setTagVisible(Parse.Constants.TAG_POLYGON_FILL, isActive);
	}

	public onKeyEvent(): void {
		// Empty on purpose
	}

	public onClick(): void {
		// Empty on purpose
	}

	protected override isDisabled(): boolean {
		if (this.context?.drawingManager) {
			for (const tag of this.context.drawingManager.getDrawingTags()) {
				if (tag === Parse.Constants.TAG_POLYGON_FILL) {
					return false;
				}
			}
		}

		return true;
	}
}

TogglePolygonFillToolbarItem.contextType = DrawingManagerContext;
